import 'core-js/stable'
import 'regenerator-runtime/runtime'

import initGlobal, { initPageFooter, initPageHeader } from '@bikemap/js/integrations/global'
import replaceCounters from '@bikemap/js/integrations/counters'

initGlobal()
initPageHeader()
initPageFooter()
replaceCounters()
